import React from 'react';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';


/**
 * Dialog content can be scrollable.
 */
export default class Grading extends React.Component {
  state = {
    open: false,
  };

  handleOpen = () => {
    this.setState({open: true});
  };

  handleClose = () => {
    this.setState({open: false});
  };

  render() {
    const actions = [
      <FlatButton
        label="OK"
        keyboardFocused={true}
        primary={true}
        onClick={this.handleClose}
      />
    ];

    const dialogArray = [

    ]

    return (

      <div>


        <div>
        <RaisedButton label="Submit" onClick={this.handleOpen} style = {{marginLeft: 120}} />
        </div>

        <Dialog
          title="You missed:"
          actions={actions}
          modal={false}
          open={this.state.open}
          onRequestClose={this.handleClose}
          autoScrollBodyContent={true}
        >

          {//using props that you get from Aa1Info.js to check if they are the correct answers
            }
          {this.props.joule == "N*m" ? null : <div> Joules </div> }
          {this.props.watt == "J/s" ? null : <div> Watts </div>}
          {this.props.pascal == "N/(m^2)" ? null : <div> Pascals </div>}
          {this.props.ampere == "C/s" ? null : <div> Amperes </div>}
          {this.props.volt == "J/C" ? null : <div> Volts </div>}
          {this.props.ohm == "V/A"  ? null : <div> Ohms </div>}
          {this.props.farad == "C/V" ? null : <div> Farads </div>}
          {this.props.newton == "(kg*m)/(s^2)" ? null : <div> Newtons </div>}
          {this.props.hertz == "1/s" ? null : <div> Hertz </div>}


          {//if the user gets all the questions right, then he will get a response saying none
            this.props.joule == "N*m" && this.props.watt == "J/s" && this.props.pascal == "N/(m^2)"
          && this.props.ampere == "C/s" && this.props.volt == "J/C" && this.props.ohm == "V/A"
          && this.props.farad == "C/V" && this.props.newton == "(kg*m)/(s^2)"
          && this.props.hertz == "1/s" ? <div> Nothing, good work. </div> : null}





        </Dialog>

      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/SIUnits/grading.js